<div *ngIf="!lead">
  <form [formGroup]="deductionForm" (ngSubmit)="onSubmit()">
    <mat-dialog-content>
      <p
        *ngIf="
          studentListStatus === studentStatus.active &&
          type === noteType.EXPULSION
        ">
        Вы пытаетесь отчислить студента {{ student?.full_name }}. Доступ к
        новому материалу будет закрыт. К материалу который уже получил данный
        студент, доступ будет ещё открыт. Чтобы вернуть студента опять в данную
        группу, нужно будет его активировать во вкладке "Отчисленные".
      </p>

      <p
        *ngIf="
          type === noteType.BLOCKING &&
          studentListStatus === studentStatus.inactive
        ">
        Вы пытаетесь заблокировать студента {{ student?.full_name }}. У студента
        не будет доступа к материалу который он уже получил, также студент не
        сможет зайти в crm систему под своим профилем. Чтобы студента опять
        активировать, можно перейти во вкалдку "Заблокированные" либо в профиль
        студента и нажать на кнопку "Активировать | Разблокировать". Тогда у
        студента открывается доступ к материалу который он получил и профиль
        становится активным.
      </p>

      <mat-form-field appearance="outline">
        <mat-label
          *ngIf="
            studentListStatus === studentStatus.active &&
            type === noteType.EXPULSION
          "
          >Причина отчисления:
        </mat-label>
        <mat-label
          *ngIf="
            studentListStatus === studentStatus.inactive &&
            type === noteType.BLOCKING
          "
          >Причина блокировки:</mat-label
        >

        <mat-label
          *ngIf="
            studentListStatus === studentStatus.active && type === noteType.ESDP
          "
          >Комментарий:</mat-label
        >

        <textarea matInput formControlName="text"> </textarea>
      </mat-form-field>
    </mat-dialog-content>

    <div mat-dialog-actions class="justify-content-end">
      <button type="button" class="mr-2" mat-raised-button (click)="onCancel()">
        Отмена
      </button>
      <app-button-with-progress
        typeBtn="submit"
        [loading$]="sendLoading$ | async"
        label="Сохранить"></app-button-with-progress>
    </div>
  </form>
</div>

<div *ngIf="lead">
  <form [formGroup]="deductionForm" (ngSubmit)="onSubmit()">
    <mat-dialog-content>
      <mat-form-field appearance="outline">
        <mat-label>Комментарий:</mat-label>
        <textarea matInput formControlName="text"> </textarea>
      </mat-form-field>
    </mat-dialog-content>
    <div mat-dialog-actions class="justify-content-end">
      <button type="button" class="mr-2" mat-raised-button (click)="onCancel()">
        Отмена
      </button>
      <app-button-with-progress
        typeBtn="submit"
        [loading$]="sendLoading$ | async"
        label="Сохранить"></app-button-with-progress>
    </div>
  </form>
</div>
